export const alertListMapping = {
  alert: {
    types: [
      {
        name: 'Activity',
        type: 'ACTIVITY_ALERT',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/Activity.jpg',
      },
      {
        name: 'Container',
        type: 'WAREHOUSE_ALERT',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/Container.jpg',
      },
      {
        name: 'Device',
        type: 'XSENSE_ALERT',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/Device.jpg',
      },
      {
        name: 'Equipment',
        type: 'EQUIPMENT_ALERT',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/Equipment.jpg',
      },
      {
        name: 'EquipmentTaskReceived',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/Equipment.jpg',
      },
      {
        name: 'EquipmentGeofencingIn',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/Equipment.jpg',
      },
      {
        name: 'EquipmentGeofencingOut',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/Equipment.jpg',
      },
      {
        name: 'EquipmentTaskSend',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/Equipment.jpg',
      },
      {
        name: 'Load',
        type: 'LOAD_ALERT',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/Load.jpg',
      },
      {
        name: 'Memo',
        type: 'DATE_ALERT',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/Memo.jpg',
      },
      {
        name: 'AndOr',
        type: 'ANDOR',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/AndOr.jpg',
      },
      {
        name: 'Satellite',
        type: 'SATELLITE_ALERT',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/satellite.jpg',
      },
      {
        name: 'Irrigation',
        type: 'IRRIGATION_ALERT',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/Irrigation.jpg',
      },
      {
        name: 'Disease',
        type: 'DISEASE_ALERT',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/Disease.jpg',
      },
      {
        name: 'Insects',
        type: 'INSECTS_ALERT',
        imgUrl: 'https://cdn.xfarm.ag/alert/type/Insects.jpg',
      },
    ],
  },
};
